export default __webpack_public_path__ + "static/media/5j.fa428a19.png";